import { SideNavItem } from 'app/models/SideNavItem';
import { AppDomainOverviewSectionComponent } from './sections/app-domain-overview-section/app-domain-overview-section.component';
import { AppDomainRiskOverviewSectionComponent } from './sections/app-domain-risk-overview-section/app-domain-risk-overview-section.component';
import { AppDomainDetailsSectionComponent } from './sections/app-domain-details-section/app-domain-details-section.component';
import { AppDomainIvtSectionComponent } from './sections/app-domain-ivt-section/app-domain-ivt-section.component';
import { AppDomainInventorySectionComponent } from './sections/app-domain-inventory-section/app-domain-inventory-section.component';
import { AppDomainSovSectionComponent } from './sections/app-domain-sov-section/app-domain-sov-section.component';
import { AppDomainViewabilitySectionComponent } from './sections/app-domain-viewability-section/app-domain-viewability-section.component';
import { AppDomainCtrSectionComponent } from './sections/app-domain-ctr-section/app-domain-ctr-section.component';
import { AppReferralTrafficSectionComponent } from './sections/app-referral-traffic-section/app-referral-traffic-section.component';
import { AppDomainSubdomainsSectionComponent } from './sections/app-domain-subdomains-section/app-domain-subdomains-section.component';
import { AppDomainDeviceDistributionSectionComponent } from './sections/app-domain-device-distribution-section/app-domain-device-distribution-section.component';
import { AppDomainCookieBannerSectionComponent } from './sections/app-domain-cookie-banner-section/app-domain-cookie-banner-section.component';
import { AppDomainEngagementMetricsSectionComponent } from './sections/app-domain-engagement-metrics-section/app-domain-engagement-metrics-section.component';

export const domainDetailsNavItems: SideNavItem[] = [
  {
    key: 'overview',
    iconURL: '/assets/images/icon-overview.svg',
    label: 'Overview',
    widgetComponent: AppDomainOverviewSectionComponent
  },
  {
    key: 'domain-risk-overview',
    iconURL: '/assets/images/icon-risk-overview.svg',
    label: 'Risk Overview',
    widgetComponent: AppDomainRiskOverviewSectionComponent
  },
  {
    key: 'domain-engagement-metrics',
    iconURL: '/assets/images/icon-engagement-metrics.svg',
    label: 'Engagement Metrics',
    beta: true,
    widgetComponent: AppDomainEngagementMetricsSectionComponent,
    showIf: {
      hasPermission: 'mrtDomainEngagement'
    }
  },
  {
    key: 'domain-details',
    iconURL: '/assets/images/icon-site-intelligence.svg',
    label: 'Domain Details',
    widgetComponent: AppDomainDetailsSectionComponent
  },
  {
    key: 'domain-sov',
    iconURL: '/assets/images/icon-seller-sov.svg',
    label: 'Authorized Seller',
    beta: true,
    widgetComponent: AppDomainSovSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'sellersShareDistribution/sellers'
      }
    }
  },
  {
    key: 'domain-mfa',
    iconURL: '/assets/images/icon-mfa.svg',
    label: 'Made For Advertising',
    beta: true,
    showIf: {
      hasData: {
        notEmpty: 'mfa'
      }
    }
  },
  {
    key: 'domain-cookie-banner',
    iconURL: '/assets/images/sidenav-icon-app-details.svg',
    label: 'Cookie Banner',
    widgetComponent: AppDomainCookieBannerSectionComponent,
    showIf: {
      hasPermission: 'mrtDomainCookieBanner'
    }
  },
  {
    key: 'domain-ivt',
    iconURL: '/assets/images/icon-invalid-traffic.svg',
    label: 'Invalid Traffic',
    widgetComponent: AppDomainIvtSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'ivtDistribution/byMonth'
      }
    }
  },
  {
    key: 'domain-inventory',
    iconURL: '/assets/images/icon-inventory.svg',
    label: 'Inventory',
    widgetComponent: AppDomainInventorySectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'inventoryDistribution/countries'
      }
    }
  },
  {
    key: 'domain-viewability',
    iconURL: '/assets/images/icon-viewability.svg',
    label: 'Viewability',
    widgetComponent: AppDomainViewabilitySectionComponent,
    showIf: {
      hasData: {
        notNA: 'viewabilityDistribution/nonGivtSivtViewability',
        notEmpty: 'viewabilityDistribution/byMonth'
      }
    }
  },
  {
    key: 'domain-ctr',
    iconURL: '/assets/images/icon-click-through.svg',
    label: 'Click Through',
    widgetComponent: AppDomainCtrSectionComponent,
    showIf: {
      hasData: {
        notNull: 'ctrDistribution',
        notNA: 'ctrDistribution/ctr'
      }
    }
  },
  {
    key: 'domain-referral-traffic',
    iconURL: '/assets/images/icon-referral-traffic.svg',
    label: 'Referral Traffic',
    widgetComponent: AppReferralTrafficSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'trafficDistribution/trafficSources'
      }
    }
  },
  {
    key: 'domain-sub-domains',
    iconURL: '/assets/images/icon-sub-domains.svg',
    label: 'Sub Domains',
    widgetComponent: AppDomainSubdomainsSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'subDomainDistribution/subDomains'
      }
    }
  },
  {
    key: 'domain-device-distribution',
    iconURL: '/assets/images/icon-device-distribution.svg',
    label: 'Device Distribution',
    widgetComponent: AppDomainDeviceDistributionSectionComponent,
    showIf: {
      hasData: {
        notEmpty: [
          'deviceDistribution/desktopData',
          'deviceDistribution/mobileData'
        ]
      }
    }
  }
];
